import { contentTypePluralToOneMap } from '../types/types';

export const isKnownContentType = (contentType?: string): boolean => {
  if (!contentType) {
    return false;
  }

  return Object.keys(contentTypePluralToOneMap).includes(contentType);
};
